import React from "react";
import MenuItemFooter from "./MenuItemFooter";
import MenuItemInfo from "./MenuItemInfo";
import MenuItemImages from "./MenuItemImages";
import MenuItemMinus from "./MenuItemMinus";
import MenuItemNotes from "./MenuItemNotes";
import { MenuItemAddOn } from "../../models";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import StickyFooterQuid from "../menuquid/StickyFooterQuid";
import MenuItemAddOns from "./MenuItemAddOns";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { addItemToSession } from "../../features/session/session.service";
import { getOptionId } from "../../helpers/menuItemHelper";
import { resetMenuItem } from "../../features/menuItem/menuItem.slice";
import { MenuItemIngredients } from "./MenuItemIngredients";
import { auth } from "../../firebase";
import { MenuItemAllergens } from "./MenuItemAllergens";

interface Props {
  onlyRead: boolean;
  quid?: string;
  tableFinished: boolean;
}

export const MenuItemDetail: React.FC<Props> = ({ onlyRead, quid, tableFinished }) => {
  const dispatch = useDispatch();
  
  const menuItem = useSelector((state: RootState) => state.menuItem.menuItem);
  const menuItemPath = useSelector((state: RootState) => state.menuItem.menuItemPath);
  const cookingIngredients = useSelector((state: RootState) => state.menuItem.cookingIngredients);

  const restaurantId = useSelector((state: RootState) => state.restaurant.restaurantId);
  const sessionId = useSelector((state: RootState) => state.session.sessionId);

  const [quantity, setQuantity] = React.useState(1);
  const [addOns, setAddOns] = React.useState<MenuItemAddOn[]>([]);
  const [minus, setMinus] = React.useState<any[]>([]);
  const [notes, setNotes] = React.useState('');

  const hasAddOns = (menuItem?.add_ons ?? []).length > 0;
  const hasMinus = (menuItem?.minus ?? []).length > 0;
  const hasAllergens = (menuItem?.allergens ?? []).length > 0;

  const isAddOnValid = (addOn: MenuItemAddOn, sessionAddOn: MenuItemAddOn|null): boolean => {
    const min = addOn.min_size ?? 0;
    const max = addOn.max_size ?? 1;
    const unlimited = max === 0;
  
    const optionIds = [...new Set(sessionAddOn?.options.map(getOptionId))];

    const count = sessionAddOn?.global
      ? sessionAddOn?.options.length
      : optionIds.length;

    if (count < min) return false;
    if (!unlimited && count > max) return false;

    return true;
  };

  const _checkAddOns = (): boolean => {
    if (!menuItem) return true;
  
    const invalid = menuItem.add_ons.find(addOn => !isAddOnValid(addOn, addOns.filter(a => a.title === addOn.title)[0]));

    if (invalid) {
      alert(LocalizerHelper.localized("error_options_selected"));
      return false;
    }
    console.log('_checkAddOns true');
    return true;
  };

  const _addMenuItem = async () => {
    const uid = auth.currentUser?.uid;
    console.log("_addMenuItem", restaurantId, sessionId, uid, menuItemPath, menuItem);
    if(!_checkAddOns()) return;
    if(!!restaurantId && !!sessionId && !!uid && !!menuItemPath && !!menuItem){
      await addItemToSession(
        restaurantId,
        sessionId,
        uid,
        menuItemPath,
        menuItem,
        addOns, 
        minus, 
        notes, 
        quantity
      );
    }
    _closeMenuItemDetail();
  }

  const _closeMenuItemDetail = () => {
      dispatch(resetMenuItem());
  }

  if(!menuItem) return null;

  return (
    <div style={{height: '100%'}}>
      <div className="menu-item-detail-container">
        <MenuItemImages media={menuItem.media} />
        <div className="container">
          <MenuItemInfo menuItem={menuItem} />
          <MenuItemIngredients
            menuItem={menuItem}
            cookingIngredients={cookingIngredients}
          />

          {hasAddOns && (
            <MenuItemAddOns
              menuItemAddOns={menuItem.add_ons}
              sessionItemAddOns={addOns}
              setAddOns={setAddOns}
              onlyRead={onlyRead}
            />
          )}

          {!onlyRead && hasMinus && (
            <MenuItemMinus
              menuItem={menuItem}
              minus={minus}
              setMinus={setMinus}
            />
          )}

          {!onlyRead && (
            <MenuItemNotes value={notes} onChange={setNotes} />
          )}
          {hasAllergens && <MenuItemAllergens menuItem={menuItem}/>}
        </div>

        {onlyRead ? <StickyFooterQuid quid = {quid}/>
          : <MenuItemFooter
          quantity={quantity}
          setQuantity={setQuantity}
          onAdd={_addMenuItem}
          tableFinished={tableFinished}
        />}
      </div>
    </div>
  );
};
